import { FunctionComponent, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import SwiperCard from '../swiperCard';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import ScrollMagicFn from '@/utils/ScrollMagic';

const { EFPic } = createEFPic('/img/landingPage');
interface PropsType {
    id: string;
}
const BuyKit: FunctionComponent<PropsType> = (props) => {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const [winW, setWinW] = useState(375);
    const BUY_CARD: any = {
        sa: [
            // {
            //     img: ['/img/landingPage/product/delta2_EB.webp', '/img/landingPage/product/delta2_EB.png'],
            //     title: 'm_product1',
            //     url: '',
            // },
            {
                img: ['/img/landingPage/product/DELTA_Pro_Extra_Battery.webp', '/img/landingPage/product/DELTA_Pro_Extra_Battery.png'],
                title: 'm_product2',
                url: 'https://www.amazon.ae/dp/B0B45XT3RW?ref=myi_title_dp',
            },
            {
                img: ['/img/landingPage/product/river_pro_eb.webp', '/img/landingPage/product/river_pro_eb.png'],
                title: 'm_product3',
                url: 'https://www.amazon.ae/dp/B0B31FLNV7?ref=myi_title_dp',
            },
            // {
            //     img: ['/img/landingPage/product/400w_rigid.webp', '/img/landingPage/product/400w_rigid.png'],
            //     title: 'm_product4',
            //     url: '',
            // },
            // {
            //     img: ['/img/landingPage/product/100w_rigid.webp', '/img/landingPage/product/100w_rigid.png'],
            //     title: 'm_product5',
            //     url: '',
            // },
            {
                img: ['/img/landingPage/product/400W_Solar_Panels.webp', '/img/landingPage/product/400W_Solar_Panels.png'],
                title: 'm_product6',
                url: 'https://www.amazon.ae/dp/B0B4627CBJ?ref=myi_title_dp',
            },
        ],
        za: [
            {
                title: 'm_product1',
                img: ['/img/landingPage/product/delta2_EB.webp', '/img/landingPage/product/delta2_EB.png'],
                url: 'https://za.ecoflow.com/products/delta-2-smart-extra-battery',
            },
            {
                title: 'm_product2',
                img: ['/img/landingPage/product/DELTA_Pro_Extra_Battery.webp', '/img/landingPage/product/DELTA_Pro_Extra_Battery.png'],
                url: 'https://za.ecoflow.com/products/delta-pro-smart-extra-battery',
            },
            {
                title: 'm_product3',
                img: ['/img/landingPage/product/river_pro_eb.webp', '/img/landingPage/product/river_pro_eb.png'],
                url: 'https://za.ecoflow.com/products/river-pro-extra-battery',
            },
            {
                title: 'm_product4',
                img: ['/img/landingPage/product/400w_rigid.webp', '/img/landingPage/product/400w_rigid.png'],
                url: 'https://za.ecoflow.com/products/400w-rigid-solar-panel',
            },
            {
                title: 'm_product5',
                img: ['/img/landingPage/product/100w_rigid.webp', '/img/landingPage/product/100w_rigid.png'],
                url: 'https://za.ecoflow.com/products/100w-rigid-solar-panel',
            },
            {
                title: 'm_product6',
                img: ['/img/landingPage/product/400W_Solar_Panels.webp', '/img/landingPage/product/400W_Solar_Panels.png'],
                url: 'https://za.ecoflow.com/products/400w-solar-panel',
            },
        ],
        au: [
            {
                title: 'm_product1',
                img: ['/img/landingPage/product/delta2_EB.webp', '/img/landingPage/product/delta2_EB.png'],
                url: 'https://au.ecoflow.com/products/delta-2-smart-extra-battery',
            },
            {
                title: 'm_product2',
                img: ['/img/landingPage/product/DELTA_Pro_Extra_Battery.webp', '/img/landingPage/product/DELTA_Pro_Extra_Battery.png'],
                url: 'https://au.ecoflow.com/products/delta-pro-smart-extra-battery',
            },
            {
                title: 'm_product3',
                img: ['/img/landingPage/product/river_pro_eb.webp', '/img/landingPage/product/river_pro_eb.png'],
                url: 'https://au.ecoflow.com/products/river-pro-extra-battery',
            },
            {
                title: 'm_product4',
                img: ['/img/landingPage/product/400w_rigid.webp', '/img/landingPage/product/400w_rigid.png'],
                url: 'https://au.ecoflow.com/products/400w-rigid-solar-panel',
            },
            {
                title: 'm_product5',
                img: ['/img/landingPage/product/100w_rigid.webp', '/img/landingPage/product/100w_rigid.png'],
                url: 'https://au.ecoflow.com/products/100w-rigid-solar-panel',
            },
            {
                title: 'm_product6',
                img: ['/img/landingPage/product/400W_Solar_Panels.webp', '/img/landingPage/product/400W_Solar_Panels.png'],
                url: 'https://au.ecoflow.com/products/400w-portable-solar-panel',
            },
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWinW(window?.innerWidth || 375);
        }
    }, []);

    // 动画
    let ScrollMagic: any;
    let controller: any;
    if (typeof window !== 'undefined') {
        ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }
    useEffect(() => {
        controller = new ScrollMagic.Controller();
        return () => {
            (ScrollMagic = null), (controller = null);
        };
    }, []);

    const [generatorEnter, setGeneratorEnter] = useState<boolean>(false);
    useEffect(() => {
        const origin = '.scroll-trigger-origin-I';
        const scene = new ScrollMagic.Scene({ triggerElement: origin, triggerHook: 'onEnter', offset: window.innerHeight / 2 });
        scene.on('enter', () => setGeneratorEnter(true));
        scene.on('leave', () => setGeneratorEnter(false));
        controller.addScene(scene);
    }, []);

    return (
        <div className={css.buyKit} id={props.id}>
            <div className="content">
                <div className="uninterrupted-power uninterrupted-power2 scroll-trigger-origin-I">
                    <EFPic name={['/h5/solution/generator.webp', '/h5/solution/generator.png']} alt={t('delta_pro_whole_homesec.I_title')} />
                    <div className={`text-box-wrap  content-generator-text ${generatorEnter ? 'to' : 'from'}`}>
                        <div className="text-box">
                            <div className="title">{t('secI_title')}</div>
                            <div className="text">{t('secI_desc')}</div>
                        </div>
                    </div>
                </div>
                <div className="swiper generator-swiper">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        className="solution-detail-swiper"
                        pagination={{
                            clickable: true,
                        }}
                        navigation={false}
                        initialSlide={0}
                        autoplay={false}
                        speed={800}
                        centeredSlides={true}
                        lazy={true}
                        spaceBetween={(winW / 375) * 10}
                        slidesPerView={'auto'}
                    >
                        {BUY_CARD[locale]?.map((item: any, k: number) => (
                            <SwiperSlide key={k} className="generator-slide">
                                <SwiperCard item={item} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};
export default BuyKit;
